import { Link } from 'react-router'
import { useTrackerHref } from '@/provider/useTrackerHref'

export default function NotFound() {
  const href = useTrackerHref()

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4">
      <p className="text-muted-foreground">404 — page not found</p>
      <Link to={href('/')} className="text-primary">
        Go home
      </Link>
    </div>
  )
}
